import Loadable from 'react-loadable';
import { RouteLoading } from './RouteLoading';

const PreCadastroLojas = Loadable({
  loader: () => import('../views/Lojas/PreCadastro'),
  loading: RouteLoading,
});

const ConsultaLoja = Loadable({
  loader: () => import('../views/Lojas/Consulta'),
  loading: RouteLoading,
});

const LojaVisualizar = Loadable({
  loader: () => import('../views/Lojas/Visualizar'),
  loading: RouteLoading,
});

const UploadLoja = Loadable({
  loader: () => import('../views/Lojas/UploadLoja'),
  loading: RouteLoading,
});

const ConsultaParametrizacaoDocumentos = Loadable({
  loader: () => import('../views/Lojas/Parametrizacao/Documentos'),
  loading: RouteLoading,
});

const EditarParametrizacaoDocumentos = Loadable({
  loader: () => import('../views/Lojas/Parametrizacao/Documentos/GrupoAbono'),
  loading: RouteLoading,
});

const ParametrizacaoNovoDocumento = Loadable({
  loader: () =>
    import('../views/Lojas/Parametrizacao/Documentos/NovoDocumento'),
  loading: RouteLoading,
});

const PreAnalise = Loadable({
  loader: () => import('../views/Lojas/PreAnalise'),
  loading: RouteLoading,
});

const Relatorios = Loadable({
  loader: () => import('../views/Lojas/Relatorios'),
  loading: RouteLoading,
});

const AnaliseDash = Loadable({
  loader: () => import('../views/Lojas/AnaliseDash'),
  loading: RouteLoading,
});
const Cockpit = Loadable({
  loader: () => import('../views/Lojas/Cockpit'),
  loading: RouteLoading,
});

const AnaliticoCockpitLoja = Loadable({
  loader: () => import('../views/Lojas/Cockpit/Analitico'),
  loading: RouteLoading,
});
const Dashboard = Loadable({
  loader: () => import('../views/Lojas/Dashboard'),
  loading: RouteLoading,
});
const AnaliticoDashboardLoja = Loadable({
  loader: () => import('../views/Lojas/Dashboard/Analitico'),
  loading: RouteLoading,
});
const NovaCritica = Loadable({
  loader: () => import('../views/Lojas/Parametrizacao/Documentos/NovaCritica'),
  loading: RouteLoading,
});
const ParametrizacaoDocumentosCritica = Loadable({
  loader: () => import('../views/Lojas/Parametrizacao/Documentos/Critica'),
  loading: RouteLoading,
});
const CargaFebraban = Loadable({
  loader: () => import('../views/Lojas/Parametrizacao/CargaFebraban'),
  loading: RouteLoading,
})
const CargaModalidade = Loadable({
  loader: () => import('../views/Lojas/Parametrizacao/CargaModalidade'),
  loading: RouteLoading,
})

const RouteLojas = [
  {
    path: '/lojas/pre-cadastro',
    exact: true,
    name: 'Pré-Cadastro de Lojas',
    component: PreCadastroLojas,
  },
  {
    path: '/lojas/consulta',
    exact: true,
    name: 'Consulta de Lojas',
    component: ConsultaLoja,
  },
  {
    path: '/lojas/consulta/visualizar/:mode',
    exact: true,
    name: 'Visualizar Loja',
    component: LojaVisualizar,
  },
  {
    path: '/lojas/upload/:type/:mode',
    exact: true,
    name: 'Upload de Documentos',
    component: UploadLoja,
  },
  {
    path: '/lojas/documentos',
    exact: true,
    name: 'Parametrização / Documentos',
    component: ConsultaParametrizacaoDocumentos,
  },
  {
    path: '/lojas/documentos/grupo/:IdCriterio',
    exact: true,
    name: '',
    component: EditarParametrizacaoDocumentos,
  },
  {
    path: '/lojas/documentos/novo-documento/:IdCriterio',
    exact: true,
    name: 'Novo Documento',
    component: ParametrizacaoNovoDocumento,
  },
  {
    path: '/lojas/pre-analise',
    exact: true,
    name: 'Pré-Análise',
    component: PreAnalise,
  },
  {
    path: '/lojas/relatorios',
    exact: true,
    name: 'Relatórios',
    component: Relatorios,
  },
  {
    path: '/lojas/analise',
    exact: true,
    name: 'Análise',
    component: AnaliseDash,
  },
  {
    path: '/lojas/cadastro',
    exact: true,
    name: 'Cadastro',
    component: AnaliseDash,
  },
  {
    path: '/lojas/cadastro/visualizar/:mode',
    exact: true,
    name: 'Análise de Cadastro',
    component: LojaVisualizar,
  },
  {
    path: '/lojas/conferencia',
    exact: true,
    name: 'Conferência',
    component: AnaliseDash,
  },
  {
    path: '/lojas/conferencia/visualizar/:mode',
    exact: true,
    name: 'Análise de Conferência',
    component: LojaVisualizar,
  },
  {
    path: '/lojas/prevencao-fraude',
    exact: true,
    name: 'Prevenção à Fraude',
    component: AnaliseDash,
  },
  {
    path: '/lojas/prevencao-fraude/visualizar/:mode',
    exact: true,
    name: 'Análise Prevenção à Fraude',
    component: LojaVisualizar,
  },
  {
    path: '/lojas/analisePlanejamentoComercial',
    exact: true,
    name: 'Planejamento Comercial',
    component: AnaliseDash,
  },
  {
    path: '/lojas/analisePlanejamentoComercial/visualizar/:mode',
    exact: true,
    name: 'Análise Planejamento Comercial',
    component: LojaVisualizar,
  },
  {
    path: '/lojas/analise-credito-pel',
    exact: true,
    name: 'Análise do Crédito (PEL)',
    component: AnaliseDash,
  },
  {
    path: '/lojas/analise-credito-pel/visualizar/:mode',
    exact: true,
    name: 'Parecer Análise do Crédito (PEL)',
    component: LojaVisualizar,
  },
  {
    path: '/lojas/prevencao-pld',
    exact: true,
    name: 'Prevenção PLD',
    component: AnaliseDash,
  },
  {
    path: '/lojas/prevencao-pld/visualizar/:mode',
    exact: true,
    name: 'Análise Prevenção PLD',
    component: LojaVisualizar,
  },
  {
    path: '/lojas/cockpit',
    exact: true,
    name: 'Cockpit',
    component: Cockpit,
  },
  {
    path: '/lojas/cockpit/analitico/:fila',
    exact: true,
    name: 'Analítico',
    component: AnaliticoCockpitLoja,
  },
  {
    path: '/lojas/dashboard',
    exact: true,
    name: 'Dashboard',
    component: Dashboard,
  },
  {
    path: '/lojas/dashboard/analitico/:fila/:conforme',
    exact: true,
    name: 'Analítico',
    component: AnaliticoDashboardLoja,
  },
  {
    path: '/lojas/parametrizacao/documentos/critica-edicao',
    exact: true,
    name: 'Parametrização / Documentos / Editar Crítica',
    component: NovaCritica,
  },
  {
    path: '/lojas/parametrizacao/documentos/critica-nova',
    exact: true,
    name: 'Parametrização / Documentos / Nova Crítica',
    component: NovaCritica,
  },
  {
    path: '/lojas/parametrizacao/critica/:IdCriterio',
    exact: true,
    name: 'Parametrização / Crítica',
    component: ParametrizacaoDocumentosCritica,
  },
  {
    path: '/lojas/parametrizacao/carga-febraban',
    exact: true,
    name: 'Parametrizacão / Carga Febraban',
    component: CargaFebraban,
  },
  {
    path: '/lojas/parametrizacao/carga-modalidade',
    exact: true,
    name: 'Parametrizacão / Carga Modalidade',
    component: CargaModalidade,
  }
];

export { RouteLojas };
